import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import ServiceIcon from './ServiceIcon'
import { themeColor, themeFontSize, themeFontWeight } from '@elparking/components'

const RestServicesIcon = styled.div`
    width: 20px;
    height: 20px;
    line-height: 20px;
    border-radius: 50%;
    border: solid 1px ${themeColor('gray60')};
    color: ${themeColor('gray60')};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: ${themeFontSize('xxxSmall')};
    font-weight: ${themeFontWeight('book')};
`

const Services = ({ services, max }) => {
    const restServices = max > 1 ? services.length - max : 0
    let maxServices = max > 1 ? services.slice(0, max) : services
    if (restServices === 1) {
        maxServices = services.slice(0, max + 1)
    }

    if (!maxServices || maxServices.length === 0) {
        return null
    }

    return (
        <>
            {maxServices.map((service) => <ServiceIcon key={service.id} serviceName={service.name} serviceSlug={service.slug} />)}
            {restServices > 1 && <RestServicesIcon>{restServices}+</RestServicesIcon>}
        </>
    )
}

Services.propTypes = {
    services: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        slug: PropTypes.string,
    })),
    max: PropTypes.number,
}

Services.defaultProps = {
    max: 0,
}

export default Services
